import React from 'react';

export const NoData = ({ text = 'No Data Found' }) => {
  return (
    <div className='container d-flex justify-content-center'>
      <div className='nodatatxt'>{text}</div>
    </div>
  );
};
